module.exports = __webpack_public_path__ + "static/media/Chubut.5d1daf1a.svg";